import BN from 'bn.js'
import Web3 from 'web3'
import { Contract } from 'web3-eth-contract'

import CONTRACT_ERC20 from '../contracts/ERC20.json'
import { NetworkType } from './network'

export type TokenMetadataType = {
  address: string
  name: string
  symbol: string
  decimals: string
  balance?: string
  load?: boolean
  allowance?: number
  contract: Contract
  account?: string
}

export const fromHRToBN = (n: number, decimals: number) => {
  const MAX_SMALL_DECIMAL = 6
  if (decimals <= MAX_SMALL_DECIMAL) {
    return new BN(10).pow(new BN(decimals)).muln(n)
  }

  const multiplierSmall = new BN(10).pow(new BN(MAX_SMALL_DECIMAL))
  const multiplierMain = new BN(10).pow(new BN(decimals - MAX_SMALL_DECIMAL))

  return multiplierSmall.muln(n).mul(multiplierMain)
}

export const toHRNumber = (bn: BN, decimal = 0) => bn.div(new BN(10).pow(new BN(decimal))).toNumber()
export const toHRNumberFloat = (bn: BN, decimal = 0) => toHRNumber(bn.muln(100), decimal) / 100
export const tokenToDecimals = (token: string, decimals: number) => Number(token) / 10 ** decimals

export const countDecimals = function (value: number) {
  const text = value.toString()
  // verify if number 0.000005 is represented as "5e-6"
  if (text.indexOf('e-') > -1) {
    const [, trail] = text.split('e-')
    const deg = parseInt(trail, 10)
    return deg
  }
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0
  }
  return 0
}

export const getTokenMetadata = async (web3: Web3, chain: NetworkType, address: string, account?: string) => {
  const tokenContract = new web3.eth.Contract(CONTRACT_ERC20 as any, address)
  const balance = account ? await tokenContract.methods.balanceOf(account).call() : undefined
  const allowance = account
    ? await tokenContract.methods.allowance(account, process.env.REACT_APP_JAMON_RULETTE_ADDRESS).call()
    : '0'

  const decimals = await tokenContract.methods.decimals().call()

  return {
    address,
    account,
    balance,
    name: await tokenContract.methods.name().call(),
    symbol: await tokenContract.methods.symbol().call(),
    decimals,
    allowance: tokenToDecimals(allowance, decimals),
    load: true,
    contract: tokenContract,
  } as TokenMetadataType
}
